import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styles from './styles.scoped.css';
import { Modal, ScrollArea } from '@mantine/core';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSettingMerchantDetail } from '../../../pages/SettingMerchant/actions';
import Button from '../../elements/Button';
import SuspendMerchantForm from '../../forms/SuspendMerchantForm';
import EditAgentForm from '../../forms/EditAgentForm';

export default function ModalSettingMerchant({
  handleSubmit,
  merchantName,
  merchantId,
  onClose,
  open,
  type,
  withLine,
  // onOpenModalChangePassword = () => {},
  // values = {}
}) {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.merchantSetting.detail);
  const [lastUpdate, setLastUpdate] = useState(0);

  const content = {
    'resend-account': {
      title: 'Kirim Ulang Akun',
      subtitle: (
        <>
          Apa Anda ingin untuk mengirimkan ulang akun ke email{' '}
          <strong>{merchantName}</strong>?
        </>
      ),
      component: null,
      footer: (
        <div className={styles.modalAction}>
          <Button onClick={onClose}>Batal</Button>
          <Button onClick={handleSubmit}>
            Kirim
          </Button>
        </div>
      ),
    },
    'edit-merchant': {
      title: 'Ubah Data Pangkalan LPG 3 Kg',
      subtitle: (
        <>
          Apa Anda yakin untuk mengubah data <strong>{merchantName}</strong>?
        </>
      ),
      component: null,
      footer: (
        <div className={styles.modalAction}>
          <Button onClick={onClose}>Batal</Button>
          <Button onClick={handleSubmit}>
            Ya, ubah
          </Button>
        </div>
      ),
    },
    suspend: {
      title: data?.isSuspend ? 'Buka Suspend' : 'Suspend Pangkalan LPG 3 Kg',
      subtitle: (
        <>
          {data?.isSuspend
            ? ' Apa Anda ingin untuk membuka suspend '
            : 'Apa Anda yakin untuk suspend'}{' '}
          <strong>{merchantName}</strong>?
        </>
      ),
      component: (
        <SuspendMerchantForm
          handleClose={onClose}
          handleSubmit={handleSubmit}
          merchantId={merchantId}
        />
      ),
      footer: null,
    },
    'block-pin': {
      title: 'Blokir PIN Pangkalan',
      subtitle: (
        <>
          Apakah Anda ingin untuk blokir PIN {' '}
          <strong>Pangkalan {merchantName}</strong>?
        </>
      ),
      component: null,
      footer: (
        <div className={styles.modalAction}>
          <Button onClick={onClose}>Batal</Button>
          <Button onClick={handleSubmit}>
            Blokir PIN
          </Button>
        </div>
      ),
    },
    'non-active': {
      title: 'Nonaktifkan Pencatatan Manual',
      subtitle:
        'Jika Anda menonaktifkan pencatatan manual, user akan tidak dapat lagi untuk mengakses pencatatan manual.',
      component: null,
      footer: (
        <div className={styles.modalAction}>
          <Button onClick={onClose}>Batal</Button>
          <Button onClick={handleSubmit} style="danger">
            Non Aktifkan
          </Button>
        </div>
      ),
    },
    'ubah-agen': {
      title: 'Ganti Agen',
      component: (<EditAgentForm
        data={data}
        handleSubmitAgent={handleSubmit}
        onClose={onClose} />),
      footer: null,
    }
  };

  useEffect(() => {
    setLastUpdate(new Date().getMilliseconds());
  }, [data?.isSuspend]);

  useEffect(() => {
    if (merchantId) {
      dispatch(fetchSettingMerchantDetail(merchantId));
    }
  }, [merchantId]);

  return (
    <Modal
      centered
      lastUpdate={lastUpdate}
      onClose={onClose}
      opened={open}
      scrollAreaComponent={ScrollArea.Autosize}
      size={'auto'}
    // withCloseButton={false}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h4>{content[type].title}</h4>
          {withLine && <hr className={styles.separatorModalSettingMerchant}/>}
          <p>{content[type].subtitle}</p>
        </div>
        {content[type].component}
      </div>
      {content[type].footer}
    </Modal>
  );
}

ModalSettingMerchant.propTypes = {
  handleSubmit: PropTypes.func,
  merchantId: PropTypes.string,
  merchantName: PropTypes.string,
  onClose: PropTypes.func,
  onOpenModalChangePassword: PropTypes.func,
  open: PropTypes.bool,
  type: PropTypes.oneOf([
    'resend-account',
    'suspend',
    'edit-merchant',
    'non-active',
    'ubah-agen'
  ]),
  values: PropTypes.object,
  withLine: PropTypes.bool,
};
